import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { StorageService, UsuariosService } from '../../../servicios/index.service';
import 'rxjs/add/operator/map';
declare var $;

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html'
})

export class NavbarComponent implements OnInit {

  navbar:boolean;
  datos_user:any = {};
  ser_notify:any;
  num:any;
  notiServ:boolean;
  rol_user:string;
  @Output() idService = new EventEmitter;
  @Output() btnCancelar =  new EventEmitter;
  @Output() buscador = new EventEmitter;
  btnSidebar:boolean = false;
  btnNavbar:boolean = false;
  verBtn:boolean;
  id_params:any;
  noti_servicio:number = 0;
  numero:number;
  itemCancelaServ:any;
  audio = new Audio();
  servicios_notify:any;
  notificaciones_user:any;
  notificaciones_user_subs:any;
  num_notifi:any;
  numero_notify:any;

  constructor( private _storage:StorageService, public router:Router, private _us:UsuariosService,
                private routerAct: ActivatedRoute) {
                this.routerAct.params.subscribe(data=>{
                  this.id_params = data.id;
                });
                this.mostrar_navbar();
                this.datos();
                this.roles();
                this.itemCancelaServ = this._storage.consult_storage("rol");

  }

  ngOnInit() {

    if(this.servicios_notify){

    }
    if(this.notificaciones_user_subs == undefined){
      let st = this._storage.consult_storage("rol");
      if(st == "2" || st == "account-man" || st == "account-adm"|| st == "account-espe"){
        this.servicios();
        this.notificaciones();
      }
    }

  }

  ngOnDestroy() {

      if(this.notificaciones_user_subs){
        this.notificaciones_user_subs.unsubscribe();
      }
      if(this.servicios_notify){
        this.servicios_notify.unsubscribe();
      }
  }

  servicios(){
    this.servicios_notify = this._us.cosnulta_serv().map(res=>res).subscribe(data=>{
      console.log(data);
      this.ser_notify = data;
      this.num = data.length;
      let num = 0;
      for( let item of this.ser_notify ){
        if( item.status == 0 ){
            if( item.status_notify == 0 || item.status_notify == null){
              this.sonido_notifi_serv();
              $.notify({
                icon: 'fa fa-dot-circle-o',
                title:"<b>Nuevo servicio</b><br>",
                message:"Se creó un nuevo servicio:"+ item.nom_empresa
              },{
                timer: 100000
              });
              this._us.status_notifi(item.$key).then(()=>{});
            }
          num++;
        }
      }
      this.numero = num;
    });
  }

  notificaciones(){
    this.notificaciones_user_subs = this._us.consult_notificaciones().subscribe(data=>{
      this.notificaciones_user = data;
      this.num_notifi = data.length;
      let num = 0;
      for( let item of this.notificaciones_user ){
        if( item.status_notifi == 0 ){

          if( item.clave_msj == "NOTIFY_1" ){
            this.sonido_notifi_event();
            this.notificacion_msj(item.user,"inicio sesión.", "primary");
            this._us.status_notifi_event(item.$key).then(()=>{});
          }else if( item.clave_msj == "NOTIFY_2" ){
            this.sonido_notifi_event();
            this.notificacion_msj(item.user,"cerro sesión.", "warning");
            this._us.status_notifi_event(item.$key).then(()=>{});
          }else if( item.clave_msj == "NOTIFY_3" ){
            this.sonido_notifi_event();
            this.notificacion_msj(item.user, "acepto el servicio", "primary");
            this._us.status_notifi_event(item.$key).then(()=>{});
          }else if( item.clave_msj == "NOTIFY_4" ){
            this.sonido_notifi_event();
            this.notificacion_msj(item.user, "cancelo el servicio asignado.", "danger");
            this._us.status_notifi_event(item.$key).then(()=>{});
          }else if( item.clave_msj == "NOTIFY_5" ){
            this.sonido_notifi_event();
            this.notificacion_msj(item.user, "se le agoto el tiempo de respuesta: servicio cancelado", "danger");
            this._us.status_notifi_event(item.$key).then(()=>{});
          }else if( item.clave_msj == "NOTIFY_6" ){
            this.sonido_notifi_event();
            this.notificacion_msj(item.user, "cancelo el servicio en curso asignado", "danger");
            this._us.status_notifi_event(item.$key).then(()=>{});
          }else if( item.clave_msj == "NOTIFY_7" ){
            this.sonido_notifi_event();
            this.notificacion_msj(item.user, "Ha llegado al lugar de carga", "success");
            this._us.status_notifi_event(item.$key).then(()=>{});
          }else if( item.clave_msj == "NOTIFY_8" ){
            this.sonido_notifi_event();
            this.notificacion_msj(item.user, "Ha llegado al lugar de carga", "info");
            this._us.status_notifi_event(item.$key).then(()=>{});
          }else if(item.clave_msj == "PANIC"){
            this.sonido_panico();
            this.notificacion_msj(item.user, "Presiono el botón de pánico", "danger");
            this._us.status_notifi_event(item.$key).then(()=>{});
          }else{
            alert("Error es posible que el registro no tenga msj o verifica la conexion a internet");
          }

          num++;
        }
      }
      this.numero_notify = num;
    });
  }

  mostrar_navbar(){

    if( this.router.url == "/home" || this.router.url == "/seguimiento/" + this.id_params ){
      this.verBtn = true;
    }else{
      this.verBtn = false;
    }

    let st = this._storage.user_consult();
    if(st){
      this.navbar = true;
    }else{
      this.navbar = false;
    }
  }
  datos(){
    let user = this._storage.consult_storage("user");
    this._us.valida_datos(user).map(res=>res).subscribe(data=>{
      this.datos_user = data;
    });
  }
  roles(){
    let ls = this._storage.consult_storage('rol');
    if( ls == '1' ){
        this.notiServ = false;
        this.rol_user = "Servicio";
    }
    if( ls == '2' ){
      this.notiServ = true;
      this.rol_user = "Monitoreo";
    }
    if( ls == "accoun-adm" ){
      this.notiServ = true;
      this.rol_user = "Administrador";
    }
    if( ls  == "account-espe" ){
      this.notiServ = true;
      this.rol_user = "Usuario";
    }

  }

  noti_serv( lat:any, lng:any, key:any ){
    //console.log(key);
    this.idService.emit({'lat':lat, 'lng':lng, 'key':key, 'boton':true});
    //this.btnCancelar.emit({'boton':true});
  }

  salir(){
    this._storage.elimina_st('user');
    this.router.navigate(['login']);
  }

  sidebar_menu(){
    if(this.btnSidebar){
      $('#btn-users-navbar').removeClass('control-sidebar-open');
      this.btnSidebar = false;
    }else{
      $('#btn-users-navbar').addClass('control-sidebar-open');
      this.btnSidebar = true;
    }
  }
  main(){

    $("body").each(function(){
       let clase = $(this).attr('class');
       if(clase == "skin-blue sidebar-mini sidebar-collapse"){
         //console.log("Se cumpple",clase);
         $("section .sidebar").removeClass("hidden");
       }else{
         $(".sidebar").addClass("hidden");
         //console.log("Si no",clase);
       }
    });

  }
  sonido_notifi_serv(){
    this.audio.src = "http://216.245.211.53/app/sonidos/SD_ALERT_34.mp3";
    this.audio.load();
    this.audio.play();
  }

  sonido_notifi_event(){
    this.audio.src = "http://www.ac-sistem.mx/rastreotruck/sonidos/notification11.mp3";
    this.audio.load();
    this.audio.play();
  }

  sonido_panico(){
    this.audio.src = "http://216.245.211.53/app/sonidos/alarme.mp3";
    this.audio.load();
    this.audio.play();
  }

  salir_btn(){
    $("#logout-btn").modal();
  }

  notificacion_msj( user:any, mensaje:string, type:string ){
    if( type == "primary" ){
      $.notify({
        icon: 'fa fa-bell',
        title:"<b>Notificacion de evento</b><br>",
        message:"El usuario <b>" + user + "</b> " + mensaje
      },{
        timer: 10000
      });

    }else{
      $.notify({
        icon: 'fa fa-bell',
        title:"<b>Notificacion de evento</b><br>",
        message:"El usuario <b>" + user + "</b> " + mensaje
      },{
        timer: 10000,
        type: type
      });
    }
  }

  add_service(){
      let st_consul =  this._storage.consult_storage('btnAsig');
      if(st_consul == "false" || st_consul == undefined ){
        let st_insert = this._storage.guarda_st('btnAsig','true');
        this.buscador.emit({ 'btnAsig': true });
      }else{
        let st_insert = this._storage.guarda_st('btnAsig','false');
        this.buscador.emit({ 'btnAsig': false });
      }
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/components/shared/navbar/navbar.component.ts